import {
  Component,
  OnInit,
  inject,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import { AdvertisingService } from '../services/advertising.service';
import { Api } from '../../core/constants/api.constants';
import { AdvertisingModel } from '../../shared/models/advertising.model';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { ImageModule } from 'primeng/image';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { RoutesService } from '../../shared/services/routes.service';
import { AccessService } from '../../core/services/access.service';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { ChipModule } from 'primeng/chip';
import { GalleriaModule } from 'primeng/galleria';
import { ResourceFormCardComponent } from '../../shared/components/resource-form-card/resource-form-card.component';
import { ResourceButtonGroupComponent } from '../../shared/components/resource-button-group/resource-button-group.component';
import { AdvertisingsData } from '../models/advertising.model';
import { AdvertisingsDataInterface } from '../interfaces/advertising.interface';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { User, Users } from '../../user/models/user.model';
import { ContractModel } from '../../shared/models/contract.model';
import { BranchModel } from '../../shared/models/branch.model';
import { HttpParams } from '@angular/common/http';
import { FormService } from '../../shared/services/form.service';
import {
  UserInterface,
  UsersInterface,
} from '../../user/interfaces/user.interface';
import { DropdownModule } from 'primeng/dropdown';
import { ProfileService } from '../../profile/services/profile.service';

@Component({
  selector: 'app-advertising-list',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    TableModule,
    ButtonModule,
    ImageModule,
    ButtonGroupModule,
    ChipModule,
    GalleriaModule,
    ResourceFormCardComponent,
    ResourceButtonGroupComponent,
    MultiSelectModule,
    FormsModule,
    DropdownModule,
  ],
  templateUrl: './advertising-list.component.html',
  styleUrl: './advertising-list.component.css',
})
export class AdvertisingListComponent implements OnInit {
  protected service = inject(AdvertisingService);
  protected routesService = inject(RoutesService);
  protected formService = inject(FormService);
  private profile = inject(ProfileService).profile() as User;
  private contract = this.profile.contract as ContractModel;
  private branch = this.profile.branch as BranchModel;

  protected imageUrlBase = Api.url.base;

  rows: number = 20;

  protected access = inject(AccessService).access;
  protected resource = this.service.resource?.toLowerCase();
  protected url = Api.url.base + Api.url.images.base + '/';
  protected resources = this.formService.resources;
  protected display = model<Users>();
  protected branches = model<BranchModel[]>();
  protected contracts = model<ContractModel[]>();

  public detailed = input<boolean>(true);

  protected value = model<AdvertisingsData>();

  public length = output<number>();

  ngOnInit(): void {
    // console.log('Advertising List', {
    //   recurce: this.resource,
    // })
    this.rows = this.detailed() ? 20 : 5;
    this.service.title.update((value) => 'Lista de Pantallas');
    this.service.get().subscribe((data) => {
      this.value.update((value) => {
        value = new AdvertisingsData(data as AdvertisingsDataInterface);
        this.service.value.update((data2) => {
          data2 = value.data;
          return data2;
        });
        this.length.emit(value.totalCount);
        return value;
      });
    });
    this.getDisplay();
    this.getBranches();
    this.getContract();
  }

  onFilters(event: any) {
    // console.log('onFilters', event);
  }
  getDisplay(contract?: ContractModel, branches?: BranchModel[]) {
    console.log('get display');
    console.log(`contract: ${contract}, branches: ${branches}`);
    // if (!this.access()?.display.actions.read || !contract || !branches) {
    //   return;
    // }
    // const params: HttpParams = new HttpParams({
    //   fromObject: {
    //     contract: contract._id,
    //     branches:
    //       branches.length > 1
    //         ? branches.map((value) => value._id as string)
    //         : [],
    //     branch:
    //       branches.length == 1
    //         ? branches.map((value) => value._id as string)[0]
    //         : [],
    //   },
    // });
    const params = new HttpParams();
    return this.formService
      .getList(this.resources.display, params)
      ?.subscribe((res) => {
        this.display.update((value) => {
          return (res as UsersInterface).map(
            (value) => new User(value as UserInterface)
          );
        });
      });
  }
  getBranches(contract?: ContractModel) {
    // if ((!this.edit() && !this.create()) || !contract) {
    //   return;
    // }
    if (!this.access()?.branch.actions.read) {
      return;
    }
    // const params: HttpParams = new HttpParams({
    //   fromObject: { contract: contract._id, details: false },
    // });
    const params = new HttpParams().append('details', false);
    if (!!contract) {
      params.append('contract', contract._id);
    }
    return this.formService
      .getList(this.resources.branch, params)
      ?.subscribe((res) => {
        this.branches.update((value) => {
          return (res as BranchModel[]).map((value) => {
            return {
              _id: value._id,
              name: value.name,
            };
          });
        });
      });
  }
  getContract() {
    if (!this.access()?.contract.actions.read) {
      return;
    }
    return this.formService
      .getList(this.resources.contract)
      ?.subscribe((res) => {
        this.contracts.update((value) => {
          return (res as ContractModel[]).map((value) => {
            return {
              _id: value._id,
              name: value.name,
            };
          });
        });
      });
  }
}
